import { useEffect, useRef } from 'react';
import { $generateNodesFromDOM } from '@lexical/html';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot, $insertNodes } from 'lexical';

export default function HTMLImporter({ initialHTML, onReady }) {
  const [editor] = useLexicalComposerContext();
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!initialHTML || hasInitialized.current) {
      if (!hasInitialized.current) {
        hasInitialized.current = true;
        onReady();
      }
      return;
    }
    
    hasInitialized.current = true;

    editor.update(() => {
      const parser = new DOMParser();
      const dom = parser.parseFromString(initialHTML, 'text/html');
      const nodes = $generateNodesFromDOM(editor, dom);
      
      $getRoot().clear();
      $getRoot().select();
      $insertNodes(nodes);
    }, { discrete: true });
    
    onReady();
  }, [editor, initialHTML, onReady]);

  return null;
};
